import Policy from './Policy.container';

export default Policy;
